const initialState = {
  ui: {
    loading: true,
  }
};

export default initialState;
